<template>
  <!-- Navbar'ın olmadığı tam sayfa ekranlarda (giriş, hata) dil seçici -->
  <ul class="nav auth-locale">
    <locale />
  </ul>
</template>

<script>
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'

export default {
  components: {
    Locale,
  },
}
</script>

<style scoped>
.auth-locale {
  position: fixed;
  top: 1.5rem;
  right: 2rem;
  z-index: 10;
}
</style>
